import React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import CloudinaryImage from "../../Common/CloudinaryImage";

const Benefits = ({ title1, title2, title3, blocks, images }) => {
  return (
    <Box marginTop={{ xs: 0, lg: -16 }} marginBottom={10}>
      <Box marginBottom={5} marginX="15%" textAlign="center">
        <Typography
          variant="h4"
          component="h3"
          color="textPrimary"
          sx={{
            fontWeight: 700,
          }}
        >
          {title1}{" "}
          <Typography color={"primary"} component={"span"} variant={"inherit"}>
            {title2}
          </Typography>
          {title3 && ` ${title3}`}
        </Typography>
      </Box>

      <Grid container spacing={4}>
        {blocks.map((item, i) => (
          <Grid item xs={12} sm={6} md={3} key={i}>
            <Box
              component={Card}
              padding={4}
              borderRadius={4}
              width={"100%"}
              height={"100%"}
              data-aos={"fade-up"}
            >
              <Box display={"flex"} flexDirection={"column"}>
                <Box
                  width={images[item.image].default.width}
                  height={images[item.image].default.height}
                  mb={1}
                >
                  <CloudinaryImage
                    src={images[item.image]}
                    alt={item.title}
                    width={images[item.image].default.width}
                    height={images[item.image].default.height}
                    placeholder="blur"
                  />
                </Box>
                <Typography variant={"h6"} component="h4" gutterBottom>
                  {item.title}
                </Typography>
                <Typography color="text.secondary">{item.subtitle}</Typography>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Benefits;
